import type { ReactElement } from 'react'

import { cn } from '@/lib/utils'

interface AvatarProps {
  /** Initials shown inside the circle, e.g. "SB". */
  initials: string
  className?: string
}

/** Figma `avatar` — style=initial, colour=green. 36px (md) / 44px (lg). */
export function Avatar({ initials, className }: AvatarProps): ReactElement {
  return (
    <div
      className={cn(
        'bg-avatar-green text-avatar-text flex size-[44px] shrink-0 items-center justify-center rounded-full lg:size-[36px]',
        className,
      )}
      aria-hidden="true"
    >
      <span className="hub-label-lg text-center">{initials}</span>
    </div>
  )
}

interface AvatarWithBadgeProps extends AvatarProps {
  /** Unread count; the badge is hidden when 0. */
  count: number
  label: string
}

/** Figma `avatar-with-badge` — badge pinned top-right with a cutout ring. */
export function AvatarWithBadge({
  initials,
  count,
  label,
  className,
}: AvatarWithBadgeProps): ReactElement {
  return (
    <div className={cn('relative flex shrink-0 items-center', className)}>
      <Avatar initials={initials} />
      {count > 0 && (
        <span
          className="bg-badge-red border-badge-cutout text-badge-text hub-meta-md absolute top-[-4px] left-[24px] z-2 flex min-h-[16px] min-w-[16px] items-center justify-center rounded-full border-[1.5px] px-1 text-center"
          aria-label={label}
        >
          {count}
        </span>
      )}
    </div>
  )
}
